import { createTheme } from '@mantine/core';

/** Тема панели. Своя обвязка и свои цвета (AD-A7): ограничений WebView здесь нет. */
export const theme = createTheme({
  primaryColor: 'violet',
  defaultRadius: 'md',
});
